<template>

  <div class="ob-grid">
    <v-card class="ob-col-6">
      <asset-form-core :asset="asset" :readonly="readonly"></asset-form-core>

      <div class="row" v-if="$can('admin')">
        <v-text-field class="col-md-6" v-model="asset.shvPath" :label="$t('assets.silicon-heaven-path')" :disabled="readonly" data-test="asset-shv-path" />
        <v-text-field class="col-md-6" v-model="asset.shvSuffixPath" :label="$t('assets.silicon-heaven-path-suffix')" :disabled="readonly" data-test="asset-shv-path-suffix" />
      </div>

    </v-card>

    <v-card class="ob-col-6">
      <div v-if="$canm('assets', 'useOwners')">
        <v-autocomplete clearable hide-no-data v-model="asset.ownerId" :items="ownerIndex" :label="$tc('owners.entity-name', 1)" :disabled="readonly" item-text="ancestorsAndThisString" item-value="id" />
      </div>

      <div v-if="$store.state.site.modules.assets.assetTimes.includes('manufacturedAt')">
        <date-time-picker v-model="asset.manufacturedAt" :showTime="false" :labels="[$t('assets.manufactured-at')]" :disabled="readonly" />
      </div>

      <div v-if="$store.state.site.modules.assets.assetTimes.includes('installedAt')">
        <date-time-picker v-model="asset.installedAt" :showTime="false" :labels="[$t('assets.installed-at')]" :disabled="readonly" />
      </div>

      <div v-for="(row, index) of asset.assetAttributesInAssets" :key="index">
        <v-text-field v-model="row.value" :label="row.assetAttribute.name" :disabled="readonly" />
      </div>

      <no-data medium v-if="!asset.assetAttributesInAssets.length">
        {{ $t('assets.no-attributes') }}
      </no-data>
    </v-card>
  </div>

</template>

<script>
  import NoData from '../../shared/no-data'
  import AssetFormCore from './asset-form-core'

  export default {
    name: 'asset-form',

    props: [ 'asset', 'readonly' ],

    components: {
      AssetFormCore,
      NoData
    }
  }
</script>

<style scoped lang="scss">

  ::v-deep {
    .v-input--is-disabled {
      .v-input__slot {
        &:before,
        &:after {
          display: none;
        }

        input {
          color: rgba(0, 0, 0, 0.87)
        }
      }

      .v-input__append-inner {
        display: none;
      }
    }
  }

</style>
